// One-shot voxel color "eyedropper". The color editor (desktop-ui) arms it with
// a callback when the user clicks the dropper button; the next click on a voxel
// in the scene is intercepted by the desktop press handler (via main's
// tryEyedropSample), which reads the voxel's EXACT stored palette color and
// fires the callback with its "#rrggbb". This bypasses the rendered/lit screen
// pixel the browser's native color-picker eyedropper would sample, so the value
// matches the swatch that painted the voxel.
//
// Kept tiny + dependency-free so both the UI layer and the input pipeline can
// touch the shared armed state without importing each other.

type SampleCb = (hex: string) => void;

let pending: SampleCb | null = null;

// Arm the dropper: `cb` fires once, with the sampled color, on the next voxel
// click. Re-arming replaces any prior pending callback.
export function armEyedropper(cb: SampleCb): void {
  pending = cb;
}

export function eyedropperArmed(): boolean {
  return pending !== null;
}

// Cancel without sampling (editor closed, Escape, or toggled off).
export function disarmEyedropper(): void {
  pending = null;
}

// Deliver a sampled color and disarm. No-op (returns false) if nothing armed.
export function deliverEyedrop(hex: string): boolean {
  if (!pending) return false;
  const cb = pending;
  pending = null;
  cb(hex);
  return true;
}
